import { createFileRoute } from '@tanstack/react-router';

import { RatesPage } from '@/features/operator/rates-page';

export const Route = createFileRoute('/_operator/rates')({ component: RatesPage });
